import axios from '../../../utils/AxiosUtils';
import i18n from '../../../i18next';
import MessageUtils from "../../../utils/MessageUtils";
import {
    LOADING,
    LOAD_DEPENDS_ON_QUESTIONS_SUCCESS
} from '../../types';

export const loadDependsOnQuestions = (selectedQuestion, productDraftId, mealDealProduct, restaurantId) => {
    return(dispatch) => {
        dispatch({ type: LOADING, payload: true });

        let id = selectedQuestion.id;
        let subQuestionsParameter = '';
        
        if (mealDealProduct) {
            subQuestionsParameter = `&mealDealProduct=${mealDealProduct}&restaurantId=${restaurantId}`;
        }

        if(id == undefined && id == null) {
            id = -1;
        }

        const url = `/question-draft/${id}/depends-on-questions?productDraftId=${productDraftId}${subQuestionsParameter}`;

        axios().get(url)
            .then(response => loadDependsOnQuestionsSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.loadDependsOnFailure')));
    }
}

const loadDependsOnQuestionsSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_DEPENDS_ON_QUESTIONS_SUCCESS, payload: response.data });
}


// WEBPACK FOOTER //
// ./src/actions/restaurants/posmenu/DependsOnQuestionsAction.js